import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Grid, Box } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/HighlightOff';
import BackButtons from '../../../../../materialUi/backButton';
import AdminSubmissionTable from './adminSubmissionTable';
import { userAPI } from '../../../../../API/API-user';
import { taxReturnAPI } from '../../../../../API/API-taxReturn';
import MenuIcon from '../../../../../materialUi/menuIcon';
import AdminTableExport from './adminTableExport';
import FilterIcon from '../../../../../assets/icons/menu.png';
import DefaultAlert from '../../../../../materialUi/defaultAlert';
import AdminFilter from './adminFilter';

function AdminSubmission(
  { 
    history, 
    data, 
    handleUpdateData, 
    filteredReports, 
    handleFilter, 
    setSearchInput,
    noData
  }
  ) {
  const [taxVolunteerData, setTaxVolunteerData] = React.useState([]);
  const menuOptions = ['Download CSV', 'Print'];

  const getVolunteers = () => {
    userAPI.GET.getUsersByUserType('Tax Volunteer').then((response) => {
      setTaxVolunteerData(response.data);
    }).catch((error) => {
      console.log(error);
    });
  };

  const [defaultAlert, setDefaultAlert] = React.useState({
    open: false,
    severity: 'success',
    title: '',
    body: '',
  });

  const handleAlert = (severity, title, body) => {
    setDefaultAlert({
      open: true,
      severity,
      title,
      body,
    });
    setTimeout(() => {
      setDefaultAlert({
        open: false,
        severity,
        title,
        body,
      });
    }, 5000);
  };

  const updateTaxVolunteer = (newTaxVolunteer) => {
    taxReturnAPI.PUT.adminUpdateOneTaxReturn(newTaxVolunteer).then((response) => {
      console.log(response);
      handleUpdateData();
      handleAlert('success', 'Success', 'Tax return successfully updated!');
    }).catch((error) => {
      console.log(error);
      handleAlert('success', 'Server error', 'Please try again later');
    });
  };

  const handleChangeTaxVolunteer = (selectedVolunteer, index) => {
    if (selectedVolunteer) {
      const selectedTax = filteredReports[index];
      selectedTax.taxVolunteer = selectedVolunteer._id;
      updateTaxVolunteer(selectedTax);
    }
  };

  const exportTable = () => {
    const table = document.getElementById('table-export').innerHTML;
    const convertTable = table.toString().replace(/<div>/g, '')
      .toString().replace(/<\/div>/g, '')
      .toString()
      .replace(/<table class="table">/g, '')
      .toString()
      .replace(/<\/table>/g, '')
      .toString()
      .replace(/<td>/g, '')
      .toString()
      .replace(/<\/td>/g, ',')
      .toString()
      .replace(/<tr>/g, '')
      .toString()
      .replace(/<\/tr>/g, '\r\n')
      .toString()
      .replace(/<th scope="col">/g, '')
      .toString()
      .replace(/<\/th>/g, ',')
      .toString()
      .replace(/<thead>/g, '')
      .toString()
      .replace(/<\/thead>/g, '')
      .toString()
      .replace(/<tbody>/g, '')
      .toString()
      .replace(/<\/tbody>/g, '')
      .toString()
      .replace(/<\/t>/g, '')
      .toString()
      .replace(/<\/n>/g, '');
    const myLink = document.createElement('a');
    myLink.download = 'taxQuestionnaireList.csv';
    myLink.href = `data:application/csv,${escape(convertTable)}`;
    myLink.click();
  };

  const printTable = () => {
    const printContent = document.getElementById('table-export').innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    window.location = '/adminPortal/reports/taxes';
  };

  const handleExport = (value) => {
    if (value === 'Print') {
      printTable();
    } else {
      exportTable();
    }
  };

  React.useEffect(() => {
    getVolunteers()
  }, []);


  const [displayFilter, setDisplayFilter] = React.useState(false);
  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [statusList, setStatusList] = React.useState(
    [
      {
        label: 'Submitted',
        value: 'submitted',
        checked: false,
      },
      {
        label: 'In Review',
        value: 'inReview',
        checked: false,
      },
      {
        label: 'Missing Info',
        value: 'missingInfo',
        checked: false,
      },
      {
        label: 'CRA Issue',
        value: 'craIssue',
        checked: false,
      },
      {
        label: 'Pending',
        value: 'pending',
        checked: false,
      },
      {
        label: 'Complete',
        value: 'complete',
        checked: false,
      },
    ],
  );
  const [isapList, setIsapList] = React.useState(
    [
      {
        label: 'Eligible ISAP',
        value: 'eligible',
        checked: false,
      },
      {
        label: 'Not Eligible ISAP',
        value: 'not eligible',
        checked: false,
      },
    ],
  );

  const handleStatus = (index) => {
    const statusListCopy = statusList;
    const { checked } = statusListCopy[index];
    statusListCopy[index].checked = !checked;
    setStatusList(() => [...statusListCopy]);
    let statusArray = []
    for (let i = 0; i < statusList.length; i++){
      if(statusList[i].checked){
        statusArray.push(statusList[i])
      }
    }
    handleFilter('status', statusArray);
  };

  const handleIsap = (index) => {
    const isapCopy = isapList;
    const { checked } = isapCopy[index];
    isapCopy[index].checked = !checked;
    setIsapList(() => [...isapCopy]);
    let isapArray = []
    for(let i=0; i<isapList.length; i++){
      if(isapList[i].checked){
        isapArray.push(isapList[i])
      }
    }
    handleFilter('isap', isapArray);
  };

  const handleDates = (name, value) => {
    let dateArray = [startDate, endDate]
    if (name === 'startDate') {
      setStartDate(value);
      dateArray[0] = value;
    } else {
      setEndDate(value);
      dateArray[1] = value;
    }
    handleFilter('date', dateArray);
  };

  const resetDateFilter = () => {
    setStartDate('');
    setEndDate('');
    let dateArray = ['', ''];
    handleFilter('date', dateArray);
  };


  const searchInputHandler = (value) => {
    setSearchInput(value);
    handleFilter('search', value);
  }


  return (
    <Grid container>
       <DefaultAlert
          open={defaultAlert.open}
          severity={defaultAlert.severity}
          title={defaultAlert.title}
          body={defaultAlert.body}
          top="80px"
      />
      <Grid item xs className="taxSubmissionList-wrapper position-relative">
        <BackButtons label="Back to Reports" handleClick={() => history.push('/adminPortal/reports')} />
        <h1 className="taxSubmissionList-title">
        Tax Questionnaire Submissions
        </h1>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="taxSubmissionList-table-filter"
        >
          <Box>
            <button
              type="button"
              className="taxSubmissionList-filter-button"
              onClick={() => setDisplayFilter(!displayFilter)}
            >
              <img src={FilterIcon} alt="Search Filter" />
                Filter
            </button>
            {statusList.map((item, index) => (
              item.checked && (
                <button
                  type="button"
                  className="taxSubmissionList-selectedStatus"
                  onClick={() => handleStatus(index)}
                >
                  {item.checked && item.label}
                  <span className="ml-2">
                    <CloseIcon fontSize="small" />
                  </span>
                </button>
              )
            ))}
            {isapList.map((item, index) => (
              item.checked && (
                <button
                  type="button"
                  className="taxSubmissionList-selectedStatus"
                  onClick={() => handleIsap(index)}
                >
                  {item.checked && item.label}
                  <span className="ml-2">
                    <CloseIcon fontSize="small" />
                  </span>
                </button>
              )
            ))}
          </Box>
          <Box>
            <MenuIcon list={menuOptions} onClick={(value) => handleExport(value)} />
          </Box>
        </Grid>
        {displayFilter && (
          <Grid className="taxSubmissionList-table-filter">
            <AdminFilter
              handleStatus={handleStatus}
              statusList={statusList}
              isapList={isapList}
              handleIsap={handleIsap}
              handleSearchInput={(value) => searchInputHandler(value)}
              startDate={startDate}
              endDate={endDate}
              handleDates={handleDates}
              resetDateFilter={resetDateFilter}
            />
          </Grid>
        )}
        <AdminSubmissionTable
          data={data}
          filteredReports={filteredReports}
          taxVolunteerData={taxVolunteerData}
          handleChangeTaxVolunteer={handleChangeTaxVolunteer}
          noData={noData}
        />
      </Grid>
      <div className="table-export" id="table-export">
        <AdminTableExport
          taxVolunteerData={taxVolunteerData}
          filteredReports={filteredReports}
        />
      </div>
    </Grid>
  );
}

AdminSubmission.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  handleUpdateData: PropTypes.func.isRequired,
  noData: PropTypes.bool.isRequired,
};

export default withRouter(AdminSubmission);
